import { shallowRef } from 'vue'
import { get } from '../../../utils/index'
export function useGetCriteriaMenu({ selectionMenuUrl }) {
  const getMenus = async (params) => {
    const [res] = await get(selectionMenuUrl, params)
    return res?.data ?? []
  }

  //获取自定义查询按钮
  const customMenus = shallowRef([])
  const getCustomMenus = async (criteria) => {
    customMenus.value = await getMenus({ preset: false, criteria, visible: true })
  }

  const frontMenus = shallowRef([])
  const otherMenus = shallowRef([])
  const initGetMenus = async (criteria) => {
    const allmenus = await getMenus({ preset: true, criteria })
    frontMenus.value = allmenus.slice(0, 5)
    otherMenus.value = allmenus.slice(5)
    getCustomMenus(criteria)
  }

  return {
    initGetMenus,
    getCustomMenus,
    frontMenus,
    otherMenus,
    customMenus,
  }
}
